import { gql } from '@apollo/client'

export const GET_INVENTORY_RULES = gql`
  query GetInventoryRules($limit: Int!, $page: Int!) {
    inventoryRules(pagination: { size: $limit, page: $page }, input: {}) {
      total
      items {
        id
        name
        description
        enabled
        status
        tripsAffected
        departureAtRanges {
          startAt
          endAt
        }
        activationAtRanges {
          startAt
          endAt
        }
        exceptions {
          dow
        }
        citySegments {
          origin {
            id
            name
          }
          destination {
            id
            name
          }
          allSegments
          segments {
            id
            origin {
              id
              name
              code
            }
            destination {
              id
              name
              code
            }
          }
          allRouteServices
          routeServices {
            id
            code
          }
        }
      }
    }
  }
`

export const GET_INVENTORY_RULE = gql`
  query GetInventoryRule($inventoryRuleId: ID!) {
    inventoryRule(input: { id: $inventoryRuleId }) {
      id
      name
      description
      status
      companyID
      departureAtRanges {
        startAt
        endAt
      }
      activationAtRanges {
        startAt
        endAt
      }
      exceptions {
        dow
        routeServices {
          id
          code
        }
      }
      citySegments {
        origin {
          id
          name
          code
        }
        destination {
          id
          name
          code
        }
        allSegments
        segments {
          id
          origin {
            id
            name
            code
          }
          destination {
            id
            name
            code
          }
        }
        allRouteServices
        routeServices {
          id
          code
        }
      }
      cabinStrategies {
        id
        isDefault
        cabinSettings {
          bookingClass {
            id
            name
            priority
          }
          isActive
          maxLoadFactor
          promo
        }
        activationRanges {
          start
          end
        }
      }
    }
  }
`
